import {HashRouter, Navigate, Route, Routes} from 'react-router-dom';
import {
    getMtpDetailsPageRoute,
    getPersonPageRoute,
    getRootPageRoute,
    getTransitCentersPageRoute
} from './routes/routes';
import './styles/fonts/stylesheet.css';
import './styles/global.css';
import {ConfigProvider, Grid, notification, App as AntApp} from 'antd';
import {defaultTheme, increasedContrastTheme} from './common/theme';
import {PageLayout} from "@/components/Layout/PageLayout";
import {useEffect, useMemo, lazy} from "react";
import {useStore} from "@/store/useStore";
import {ScreenType} from "@/store/types/screenType";
import catalogueService from "@/services/catalogueService";
import {ProtectedRoute} from "@/routes/ProtectedRoute";
import {AuthProvider} from "@/provider/auth/authProvider";
import {useTallyLoader} from "@/services/TallyLoader";

const { useBreakpoint } = Grid;

/**
 * App root component
 */
export const App = () => {
    const screens = useBreakpoint();
    const setScreenType = useStore((state) => state.setScreenType);
    const useIncreasedContrastTheme = useStore((state) => state.useIncreasedContrastTheme);
    const saveRegionOptions = useStore((state) => state.saveRegionOptions);
    const includeUnavailablePlaces = useStore((state) => state.mtpFilters.includeUnavailablePlaces);
    const {renderTallyButton} = useTallyLoader();

    useEffect(() => {
        (async () => await loadRegionsAsync())();
    }, [includeUnavailablePlaces]);
    
    useEffect(() => {
        //console.log(screens);
        if (!screens.md) { // isMobile
            setScreenType(ScreenType.Mobile);
        } else if(screens.md && !screens.lg) { // isTablet
            setScreenType(ScreenType.Tablet);
        } else { // isDestop
            setScreenType(ScreenType.Desktop);
        }
    }, [screens]);

    const loadRegionsAsync = async () => {
        try {
            const res = includeUnavailablePlaces
                ? await catalogueService.getRegionsAsync()
                : await catalogueService.getRegionsWithAvailableMtpsAsync();
            saveRegionOptions(
                res.map(x => ({
                    value: x.id,
                    label: x.name.startsWith('Автономна') ? x.name : `${x.name} область`,
                })),
            );
        } catch (e) {
            notification.warning({
                message: 'Щось пішло не так ...',
                description: 'Спробуйте знову або зверніться до служби підтримки',
            });
        } finally {
            
        }
    };

    const MtpDetailsPage = useMemo(() => lazy(() => import("@/pages/MtpDetailsPage/MtpDetailsPage")), []);
    const RootPageView = useMemo(() => lazy(() => import('./pages/Root/RootPageView')), []);
    const TransitCentersPage = useMemo(() => lazy(() => import("@/pages/TransitCenters/TransitCentersPage")), []);
    const PersonCardPage = useMemo(() => lazy(() => import('@/pages/PersonCardPage/PersonCardPage')), []);

    return (
        <ConfigProvider wave={{disabled: true}} theme={useIncreasedContrastTheme ? increasedContrastTheme : defaultTheme}>
            <AntApp>
                <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    <AuthProvider>
                        <Routes>
                            <Route element={<PageLayout/>}>
                                <Route path={getMtpDetailsPageRoute()} element={<MtpDetailsPage />} />
                                <Route index path={getRootPageRoute()} element={<RootPageView />} />
                                <Route path={getTransitCentersPageRoute()} element={<TransitCentersPage />} />
                            </Route>
                            
                            {/* private routes */}
                            {/*<Route element={<ProtectedRoute />}>*/}
                            {/*    <Route element={<PageLayout />}>*/}
                            {/*        <Route path={getPersonPageRoute()} element={<PersonCardPage />} />*/}
                            {/*    </Route>*/}
                            {/*</Route>*/}
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                        {renderTallyButton()}
                    </AuthProvider>
                </HashRouter>
            </AntApp>
        </ConfigProvider>
    );
};
